import styled from 'styled-components'
import { size } from '../../../../Styles/queries'

const { mobileSPx } = size

export const EditContainer = styled.section`
    // max-width:100%;
    // background-color:blue;
`